<template>
  <CustomStylesApplier />
  <div class="_display:flex _flex-direction:column _height:100vh">
    <ILayout class="_background:white">
      <ILayoutHeader>
        <template v-if="meta">
          <meta v-if="meta.description" name="description" :content="meta.description" />
          <meta v-if="meta.keywords" name="keywords" :content="meta.keywords" />
          <meta v-if="meta.ogImage" property="og:image" :content="meta.ogImage" />
          <link v-if="meta.canonical_link" rel="canonical" :href="meta.canonical_link" />
          <meta v-if="meta.author" name="author" :content="meta.author" />
          <meta
            v-if="meta.publishedAt"
            property="article:published_time"
            :content="meta.publishedAt" />
          <meta
            v-if="meta.modifiedAt"
            property="article:modified_time"
            :content="meta.modifiedAt" />
        </template>
      </ILayoutHeader>
      <ILayoutContent>
        <div class="_margin-top:5">
          <NavBar />
          <main>
            <div class="_background:white">
              <slot />
            </div>
          </main>
        </div>
      </ILayoutContent>
      <ILayoutFooter>
        <Footer class="_margin-top:1" />
      </ILayoutFooter>
    </ILayout>
  </div>
</template>

<script setup>
  import { computed } from 'vue'
  import CustomStylesApplier from '@/Components/CustomStylesApplier.vue'
  import NavBar from '@/Components/Landing/NavBar.vue'
  import Footer from '@/Components/Landing/Footer.vue'
  import { useMeta } from '@/Composables/useMeta'

  const { metaState } = useMeta()

  // Computed property for meta data
  const meta = computed(() => metaState.value)
</script>

<style scoped>
  .header-bg {
    background-color: #ffffff;
    background-image: url('/images/grid_background_landing.svg');
    background-size: auto auto;
    background-repeat: no-repeat;
  }
</style>
